// extracted by mini-css-extract-plugin
export default {"container":"footer_container__RwPRo","content":"footer_content__n8H2W","link":"footer_link__u8nU1","item":"footer_item__8Wdc8","footer":"footer_footer__Vr6Db"};